<template>
  <AdminBackground>
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PENGURUSAN DATA.png"
          alt="PENGURUSAN DATA"
          class="pbt-image"
        >
        <div class="line-under-image" />
      </div>
      <div class="pbtpay-status">
        <h2>Data</h2>
        <VCard>
          <div class="d-flex">
            <div>
              <VTabs
                v-model="currentTab"
                direction="vertical"
              >
                <VTab
                  v-for="(tab, index) in tabs"
                  :key="index"
                  :value="tab.value"
                >
                  {{ tab.name }}
                </VTab>
              </VTabs>
            </div>

            <VCardText>
              <VWindow
                v-model="currentTab"
                class="ms-3"
              >
                <VWindowItem
                  v-for="(tab, index) in tabs"
                  :key="index"
                  :value="tab.value"
                >
                  <div
                    v-for="item in tab.items"
                    :key="item.name"
                    class="menu-item"
                  >
                    <span class="arrow-icon">➔</span>
                    <RouterLink
                      :to="item.route"
                      class="link"
                    >
                      {{ item.name }}
                    </RouterLink>
                  </div>
                </VWindowItem>
              </VWindow>
            </VCardText>
          </div>
        </VCard>
      </div>
    </div>
    <PrimaryModule />
  </AdminBackground>
</template>


<script setup>
import { ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const currentTab = ref('tab-1')

const tabs = ref([
  {
    name: 'Dasar',
    value: 'tab-1',
    items: [
      { name: 'Ahli Majlis', route: 'pengurusan-data/dasar/ahli-majlis' },
      { name: 'Lesen PBT', route: 'pengurusan-data/dasar/lesen' },
      { name: 'Pasar', route: 'pengurusan-data/dasar/pasar' },
      { name: 'Penguatkuasaan PBT', route: 'pengurusan-data/dasar/penguatkuasaan' },
      { name: 'Senarai Pbt', route: 'pengurusan-data/dasar/senarai' },
    ],
  },
  {
    name: 'Pembangunan',
    value: 'tab-2',
    items: [
      { name: 'Ringkasan Peruntukan Dan Belanja Projek BP.1', route: 'pengurusan-data/pembangunan/ringkasan-peruntukan-dan-belanja-projek-bp1' },
      { name: 'Status Pelaksanaan Projek BP.1', route: 'pengurusan-data/pembangunan/status-pelaksanaan-projek-bp1' },
      { name: 'Bajet Mengurus', route: 'pengurusan-data/pembangunan/smk' },
      { name: 'Kumpulan Wang Covid', route: 'pengurusan-data/pembangunan/kwc' },
    ],
  },
  {
    name: 'Kesihatan Persekitaran',
    value: 'tab-3',
    items: [
      { name: 'Cegah Jangkit - Program Tandas Awam Bersih', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Cegah Jangkit - Program Sanitasi dan Disinfeksi', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Vektor - Dengue Fever Information Centre (DFIC)', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Vektor - Program Kawalan Denggi', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Vektor - Tikus', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Premis Makanan - Program Keselamatan dan Kualiti Makanan', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Pasar - Program Kawalan Kebersihan Pasar', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Haiwan Terbiar - Program Kawalan Haiwan Terbiar', route: 'pengurusan-data/dasar/senarai' },
    ],
  },
  {
    name: 'Kejuruteraan Kesihatan Umum',
    value: 'tab-4',
    items: [
      { name: 'Perangkap Minyak', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Kolam Renang', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Kolam Takungan Banjir', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Lampu Jalan', route: 'pengurusan-data/dasar/senarai' },
    ],
  },
  {
    name: 'Kejuruteraan Awam',
    value: 'tab-5',
    items: [
      { name: 'Pematuhan UUK 34A (OKU) Bagi Pembangunan Projek Baharu', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Penyalahgunaan Parkir OKU', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Sistem Pengumpulan dan Penggunaan Semula Air Hujan (SPAH)', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Cerun', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Jalan', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Jalan - Blackspot', route: 'pengurusan-data/dasar/senarai' },
      { name: 'CCTV', route: 'pengurusan-data/dasar/senarai' },
    ],
  },
  {
    name: 'Khidmat Pengurusan',
    value: 'tab-6',
    items: [
      { name: 'Aset', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Latihan', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Perjawatan', route: 'pengurusan-data/dasar/senarai' },
      { name: 'Kewangan', route: 'pengurusan-data/dasar/senarai' },
      { name: 'KPI', route: 'pengurusan-data/dasar/senarai' },
      { name: 'SKT', route: 'pengurusan-data/dasar/senarai' },
    ],
  },
])
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; 
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}


.map-gap {
  margin-block: 10px; 
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
}


.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.pbtpay-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.menu-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px; 
}

.arrow-icon {
  font-size: 16px; 
  color: black; 
  margin-right: 8px;
}

.menu-item .link {
  color: #000;
  text-decoration: none;
  font-weight: 500;
}

.menu-item .link:hover {
  text-decoration: underline;
}
</style>
